<template>
  <div id="app">

    <HelloWorld></HelloWorld>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
import HelloWorld from "@/components/HelloWorld";
import Footer from "@/components/Footer";
export default {
  components: {
    HelloWorld,
    Footer,
  },
  name: "App",
  // metaInfo: {
  //   title: "Default App Title",
  //   titleTemplate: "%s | Muzik Dreamer",
  // },
  metaInfo: {
    title: "Muzik Dreamer",
    meta: [
      {
        vmid: "description",
        name: "description",
        content: "Muzik Dreamer by Ankur Luthra",
      },
      {
        vmid: "og:title",
        property: "og:title",
        content: "Muzik Dreamer - Ankur Luthra",
      },
      {
        vmid: "og:description",
        property: "og:description",
        content: "Muzik Dreamer - Ankur Luthra",
      },
      // {
      //   property: "og:image",
      //   content: "https://ahrefs.com/blog/wp-content/uploads/2019/12/fb-how-to-become-an-seo-expert.png",
      // },
      { property: "og:site_name", content: "MuzikDreamer" },
      { property: "og:type", content: "website" },
      // { name: "robots", content: "index,follow" },
    ],
  },
};
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
</style>
